export default __webpack_public_path__ + "static/media/return-policy.9fe710ed.svg";